import { WrenchIcon } from '@heroicons/react/24/outline';
import type { ReactNode } from 'react';
import { Button } from '../button/Button';
import { Text } from '../text';

type StatusCardProps = {
  className?: string;
  /** アイコン要素 */
  icon?: ReactNode;
  /** メインタイトル */
  title: string;
  /** サブタイトル */
  description?: string;
  /** ボタンテキスト */
  buttonText?: string;
  /** ボタンクリックハンドラ */
  onButtonClick?: () => void;
};

/**
 * ステータス表示用カード
 * 開発中機能や準備中状態を表示するためのカードコンポーネント
 */
export const StatusCard = ({
  className,
  icon = <WrenchIcon className="size-8 text-primary" />,
  title,
  description,
  buttonText = '閉じる',
  onButtonClick,
}: StatusCardProps) => {
  return (
    <div className={className}>
      <div className="flex flex-col items-center justify-center gap-4 rounded-xl px-6 py-10">
        {/* アイコン */}
        <div className="flex size-8 shrink-0 items-center justify-center overflow-clip rounded-xl">
          {icon}
        </div>

        {/* テキスト部分 */}
        <div className="flex w-full flex-col items-center gap-1 text-center">
          <Text variant="subhead" className="w-full text-text-base">
            {title}
          </Text>
          {description && (
            <Text variant="body" className="w-full text-text-secondary">
              {description}
            </Text>
          )}
        </div>

        {/* ボタン */}
        {onButtonClick && (
          <Button variant="outline" size="sm" onClick={onButtonClick}>
            {buttonText}
          </Button>
        )}
      </div>
    </div>
  );
};
